<template>
    <div class="statistics-container">
        <div class="playernames">
            <div class="playername" v-for="name, idx in playernames()" :key="idx">{{name}}</div>
        </div>
        <div class="stats-player-container">
            <div class="stats-unit" v-for="stats in playerstats" :key="stats.player_id">
                <div class="stat chartstat" v-if="stats.chart">
                    <canvas :id="`chart_${stats.player_id}`" :ref="`chart_${stats.player_id}`"></canvas>
                </div>
                <div class="stat" v-for="stat, key in stats['datapoints']" :key="stats.player_id + '-' + key">
                    <div class="label" v-html="__('statistics.'+key)"></div>
                    <div class="value">{{stat}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as chart from '../charts/LegStatsChart'
    export default {
        props: ['players', 'game_id', 'leg_id'],
        data() {
            return {
                playerstats: [],
                charts: [],
            }
        },
        watch: {
            leg_id: function(newVal, oldVal) { // watch it
                this.loadData();
            }
        },
        mounted() {
            // console.log('Statistiken werden geladen.')
            this.loadData();
        },
        methods: {
            loadData() {
                axios.post("/api/stats/retrieve", {"game_id": this.game_id, "leg_id": this.leg_id}).then((e) => {
                    this.playerstats = e.data;
                    this.charts.forEach(chart => {
                        chart.destroy();
                    });
                    this.charts = [];
                    setTimeout(() => {
                        this.playerstats.forEach(stats => {
                            if (stats.chart) {
                                this.charts.push(chart.drawChart(
                                    this.$refs[`chart_${stats.player_id}`],
                                    stats.chart.rounds || stats.chart.points.length,
                                    stats.chart.points,
                                    stats.chart.scores,
                                ));
                            }
                        });
                    }, 100);
                })
            },
            playernames() {
                let names = [];
                this.players.forEach(player => {
                    names.push(player.name);
                });
                return names
            }
        }
    }
</script>
